/*
  Footer link-list columns render as <details>/<summary> (see footer.liquid
  and section-footer.css) so mobile gets a real, native collapse/expand --
  no JS needed for that part.

  Desktop needs those same columns to stay always-expanded, matching how
  this footer looked before the accordion was added. Overriding the
  collapsed content's `display` via CSS was tried first and didn't
  reliably win against the browser's own native hidden-content handling
  for a closed <details> -- setting the real `open` attribute is the
  correct, robust way to keep a <details> genuinely expanded, so that's
  what this does instead, synced to the same 750px breakpoint the CSS
  uses elsewhere in this theme.
*/
(function () {
  var mql = window.matchMedia('(min-width: 750px)');

  function syncFooterAccordions(query) {
    document.querySelectorAll('.footer-block__accordion').forEach(function (details) {
      if (query.matches) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    });
  }

  syncFooterAccordions(mql);
  mql.addEventListener('change', syncFooterAccordions);
})();
